/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import"../has.js";import e from"../Logger.js";import{get as o}from"./get.js";function t(e,r,s){if(e&&r)if("object"==typeof r)for(const o of Object.getOwnPropertyNames(r))t(e,o,r[o]);else{if(-1!==r.indexOf(".")){const i=r.split("."),f=i.splice(i.length-1,1)[0];return void t(o(e,i),f,s)}e[r]=s}}e.getLogger("esri.core.accessorSupport.set");export{t as default,t as set};
